<div
  (click)="$event.stopPropagation()"
  class="date-range-picker d-inline-block"
>
  <div class="calendar" id="dropdown-calendar">
    <sui-button
      variant="secondary"
      size="sm"
      [leadingIcon]="faCalendar"
      [iconOnly]="true"
      ariaLabel="Pick date range"
      [expanded]="calendarDropdown.isOpen()"
      [suiPopoverTrigger]="rangePopover"
      #calendarDropdown="suiPopoverTrigger"
    ></sui-button>
  </div>

  <ng-template #rangePopover>
    <div
      suiPopover
      aria-labelledby="dropdown-calendar"
      class="dropdown-calendar dropdown-menu"
    >
      <div class="header">
        <div class="title">
          {{ "date-range-picker.header.select-date-time-range" | translate }}
        </div>
        <div class="close">
          <sui-button
            variant="secondary"
            size="sm"
            [leadingIcon]="['fas', 'remove']"
            [iconOnly]="true"
            ariaLabel="Close"
            (click)="cancel()"
          ></sui-button>
        </div>
      </div>

      <div class="range-picker">
        @if (companyBounds$ | async; as bounds) {
          <app-date-range-selection
            [fromDate]="fromDate"
            [toDate]="toDate"
            [minDate]="bounds.min"
            [maxDate]="bounds.max"
            (dateRangeSelection)="onDateRangeSelection($event)"
          ></app-date-range-selection>
        }
      </div>

      <div class="footer">
        <sui-button variant="secondary" (click)="cancel()">
          {{ "date-range-picker.button.cancel" | translate }}
        </sui-button>
        <sui-button variant="primary" (click)="applyDateRange()">
          {{ "date-range-picker.button.apply" | translate }}
        </sui-button>
      </div>
    </div>
  </ng-template>
</div>

@if (period$ | async; as period) {
  <div class="period">
    <span>{{ period.startTimestamp * 1000 | date: "dd MMM yyyy, HH:mm" }}</span>
    <span>{{ period.endTimestamp * 1000 | date: "dd MMM yyyy, HH:mm" }}</span>
  </div>
}
